import React from 'react'
import { useTranslation, Trans } from 'react-i18next'
import { SectionShell } from '../shared/SectionShell'

export default function StatementSection() {
    const { t } = useTranslation()

    return (
        <SectionShell id="statement" className="statement-section" theme="coral">
            <div className="statement-gradient" aria-hidden="true" />

            <div className="statement-chip-row">
                <span className="statement-chip">
                    <Trans i18nKey="statement.bannerLeft" components={{ accent: <span className="accent" /> }} />
                </span>
                <span className="statement-chip-divider" aria-hidden="true">·</span>
                <span className="statement-chip">
                    <Trans i18nKey="statement.bannerRight" components={{ accent: <span className="accent" /> }} />
                </span>
            </div>

            <div className="statement-manifesto">
                <p className="statement-line">
                    <Trans i18nKey="statement.line1" components={{ br: <br /> }} />
                </p>
                <p className="statement-line">
                    <Trans i18nKey="statement.line2" components={{ br: <br /> }} />
                </p>
                <p className="statement-line">
                    <Trans i18nKey="statement.line3" components={{ br: <br /> }} />
                </p>
            </div>

            <p className="statement-label">{t('statement.label')}</p>
        </SectionShell>
    )
}
